module.exports = __webpack_public_path__ + "media/warranty-claim/photos-wide-angle4-7983d5a0.png";